import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-light-svg-icons";

/**
 * @param {object} props
 * @param {import("react").ReactNode} props.title
 * @param {import("react").ReactNode} props.content
 * @param {(confirmed: boolean) => void} props.onDecision
 */
export default function ConfirmationDialog({ title, content, onDecision }) {
  return (
    <Dialog open onClose={() => onDecision(false)}>
      <DialogTitle>
        {title}
        <IconButton aria-label="close" onClick={() => onDecision(false)}>
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => onDecision(false)}>
          Ne
        </Button>
        <Button variant="contained" onClick={() => onDecision(true)}>
          Ano
        </Button>
      </DialogActions>
    </Dialog>
  );
}
